import React, { useEffect, useState } from "react";
import { applySortFilter } from "../../utils/tableFunctions";
import {
  Box,
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";
import ListHead from "../table/ListHead";
import Scrollbar from "../table/Scrollbar";
import SearchNotFound from "../table/SearchNotFound";
import MoreMenu from "./MoreMenu";
import EditDialogs from "./Dialogs/EditDialogs";
import DeleteDialog from "./Dialogs/DeleteDialog";
import {
  getGroupList,
  getGroupFilterConditions,
  Log,
} from "../../services/services";
import { parseDate } from "../../utils/tableFunctions";
import { StyledTableRow } from "../TableRow";
import FormSearch from "../FormSearch";
import CircularLoader from "../circularLoader";
import Label from "../Label";
import CommonDialog from "../CustomDialog";
import GroupDetails from "../../pages/details/admin/GroupDetails";
import Pagination from "../Pagination";
import { pageNumber, rowsPerPage } from "../../utils/constants";

const defaultValue = {
  is_active: true
}

const TABLE_HEAD = [
  { id: "name", label: "Name" },
  { id: "updated_at", label: "Updated On" },
  { id: "is_active", label: "Active" },
  { id: "edit" },
];

const ViewGroup = ({ userRole }) => {
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("");
  const [groupList, setGroupList] = useState({ results: [], count: 0 });
  const [loaded, setLoaded] = useState(false);
  const [inputValues, setInputValues] = useState({});

  const [pagination, setPagination] = useState({
    page: pageNumber,
    page_size: rowsPerPage,
  });

  // dialogs
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [selectedId, setSelectedId] = useState();
  const [itemId, setItemId] = useState(null);

  // filter
  const [groupFilter, setGroupFilter] = useState({});
  const [fLoaded, setFLoaded] = useState(false);
  const [activeFilter, setActiveFilter] = useState(defaultValue);

  const CustomTableCell = ({ align, field, id }) => {
    return (
      <TableCell
        align={align}
        onClick={() => {
          // window.open(`/3/app/group-details/${id}/`, "_blank");
          setItemId(id)
        }}
      >
        {field}
      </TableCell>
    );
  };

  const queryPage = (queryParams, filters) => {
    setLoaded(false);
    const targetFilter = filters !== undefined ? filters : activeFilter;
    getGroupList(setGroupList, setLoaded, targetFilter, queryParams);
    setPagination(queryParams);
    if (filters !== undefined) {
      setActiveFilter(filters);
    }
  };

  const handleChangePage = (event, newPage) => {
    queryPage({
      page: newPage,
      page_size: pagination.page_size,
    });
  };

  const handleChangeRowsPerPage = (event) => {
    queryPage({
      page: 1,
      page_size: parseInt(event.target.value, 10),
    });
  };

  const onFilterSubmit = (fParams) => {
    const newFParams = { ...fParams, name_input: inputValues?.name?.trim() || null };
    if (newFParams.is_active === 'all') delete newFParams.is_active;
    Log.info('Click button [Apply Filter] - Search Role Management list', newFParams)
    queryPage({
      page: 1,
      page_size: pagination.page_size,
    }, newFParams);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const filteredList = applySortFilter(
    groupList?.results || [],
    order,
    orderBy
  );

  const isItemNotFound = filteredList.length === 0;

  useEffect(() => {
    queryPage(pagination, defaultValue);
    getGroupFilterConditions(setGroupFilter, setFLoaded);
  }, []);

  const handleCloseDialog = () => {
    setOpenEditDialog(false);
    setOpenDeleteDialog(false);
    setSelectedId();
  };

  const schema = [
    {
      type: "search-select",
      label: "Name",
      param: "name",
      options: groupFilter?.name?.map((grp) => grp),
      inputValues,
      setInputValues,
    },
    {
      type: "select",
      label: "Active",
      param: "is_active",
      options: [
        { name: "All", id: "all" },
        { name: "Yes", id: true },
        { name: "No", id: false },
      ]
    }
  ]

  return (
    <Box>
      <FormSearch
        schema={schema}
        loading={!fLoaded}
        onSearch={onFilterSubmit}
        defaultValue={defaultValue}
      />
      {loaded ?
        <Card>
          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <ListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  onRequestSort={handleRequestSort}
                  checkbox={false}
                />
                <TableBody>
                  {loaded &&
                    filteredList.map((row) => {
                        const { id, name, updated_at, is_active } = row;

                        // if (name?.toLowerCase().includes('requester') || name?.toLowerCase().includes('removed')) {
                        //   return null;
                        // }

                        return (
                          <StyledTableRow
                            hover
                            key={id}
                          >
                            <CustomTableCell field={name} id={id} />
                            <CustomTableCell field={parseDate(updated_at)} id={id} />
                            <CustomTableCell
                              field={
                                <Label color={is_active ? "success" : "error"}>
                                  {is_active ? "YES" : "NO"}
                                </Label>
                              }
                              id={id}
                            />
                            <TableCell align="right">
                              {(userRole.includes("Edit") ||
                                userRole.includes("Delete")) && (
                                <MoreMenu
                                  setOpenDeleteDialog={setOpenDeleteDialog}
                                  setOpenEditDialog={setOpenEditDialog}
                                  setRow={() => setSelectedId(id)}
                                  userRole={userRole}
                                />
                              )}
                            </TableCell>
                          </StyledTableRow>
                        );
                      })}
                </TableBody>
                {isItemNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <SearchNotFound />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>
          {!isItemNotFound && (
            <Pagination
              count={groupList?.count || 0}
              pagination={pagination}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          )}
        </Card>
        :
        <CircularLoader />
      }
      {selectedId && (
        <>
          {openEditDialog && (
            <EditDialogs
              open={true}
              onClose={handleCloseDialog}
              selectedId={selectedId}
              setResponse={setGroupList}
              setTableLoaded={setLoaded}
            />
          )}
          {openDeleteDialog && (
            <DeleteDialog
              open={true}
              onClose={handleCloseDialog}
              selectedId={selectedId}
              setResponse={setGroupList}
              setLoaded={setLoaded}
            />
          )}
        </>
      )}

      {itemId && (
        <CommonDialog
          title="Group Details"
          onClose={() => setItemId(null)}
        >
          <GroupDetails itemId={itemId} />
        </CommonDialog>
      )}
    </Box>
  );
};

export default ViewGroup;
